import { DimensionValue, Dimensions } from 'react-native';

export const rowHeight = 78;

export const columnWidthsDesktop = {
  name: 21,
  email: 21,
  personType: 11,
  sinacorAccount: 11,
  custodyAccount: 14,
  accountBP: 11,
  action: 11,
};

export const columnWidthsTablet = {
  name: '22.5%',
  email: '22.5%',
  personType: '11%',
  sinacorAccount: '11%',
  custodyAccount: '14%',
  accountBP: '11%',
  action: '8%',
};

export const maxHeight = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.19
}px` as DimensionValue;

export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.14
}px` as DimensionValue;
